module.exports = __webpack_public_path__ + "img/jd2021_t.d5f6b28c.jpg";